/*
 *******************************************************************************
 *
 *  Filename:   /redux/slices/companyproducts.js
 *
 *  Syntax:     NA
 *
 *  Synopsis:   Company Products redux reducer
 *
 *  Author:     Norman J. Nolasco [ Archetact Software ]
 *
 *  Created:    Saturday, February 17, 2024 - 10:58 PM (CST)
 *
 *  Notes:
 *
 *  Revisions:
 *              2024/02/17  NJN Initial Build
 *
 *  Copyright (c) 2024 - Archetact Software - All Rights Reserved.
 *  Unauthorized copying of this file via any medium is strictly prohibited.
 *  Proprietary and Confidential.
 *
 *******************************************************************************
 */

import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  companyid: 0,
  company: "",
  page: "",
  error: null,
  defaultToolPanel: "",
  order: "NAME ASC",
  search: "",
  columnState: [],
};

const intFields = ["companyid"];

const updateFieldReducer = (state, action, field) => {
  const value = action.payload ? action.payload[field] : undefined;

  if (value !== undefined) {
    state[field] = intFields.includes(field) ? parseInt(value, 10) : value;
    state.error = Number.isNaN(state[field]) ? `Invalid value for ${field}.` : null;
  } else {
    state.error = `No ${field} provided.`;
  }
};

export const companySlice = createSlice({
  name: "companies",
  initialState,
  reducers: {
    updateCompanyID: (state, action) => updateFieldReducer(state, action, "companyid"),
    updateCompany: (state, action) => updateFieldReducer(state, action, "company"),
    updatePage: (state, action) => updateFieldReducer(state, action, "page"),
    updateDefaultToolPanel: (state, action) => updateFieldReducer(state, action, "defaultToolPanel"),
    updateColumnState: (state, action) => updateFieldReducer(state, action, "columnState"),
  },
});

export const { updateCompanyID, updateCompany, updatePage, updateDefaultToolPanel, updateColumnState } =
  companySlice.actions;

export default companySlice.reducer;
